import { shapeVariationsForAPI } from '../../../variations/shapeForAPI';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import ATTRIBUTE from '../../../../constants/attributes';

export function variations({ channel, preview }) {
  const payload = shapeVariationsForAPI({
    category: preview.get(ATTRIBUTE.CATEGORY),
    channel,
    profile: preview.getIn([ATTRIBUTE.VARIATIONS, 'currentProfile']),
    toImmutable: true,
    variations: preview.get(ATTRIBUTE.VARIATIONS),
  });

  return { payload: payload.set('type', OPERATIONS[channel].VARIATIONS) };
}
